import { readonly } from 'vue'
import { buildConstantsMapper } from '@/assets/scripts/mappers/constantsMapper'

/** list of modules */
const MODULES = readonly({
	/**************************************************
	*                       JOIN                      *
	**************************************************/
	JOIN_CREATE_ACCOUNT: 'joinCreateAccount',
    JOIN_SELF_ADHESION: 'joinSelfAdhesion',
	/**************************************************
	*                       HOME                      *
	**************************************************/
	HOME: 'home',
	/**************************************************
	*                     APPROVALS                   *
	**************************************************/
	APPROVALS: 'approvals',
	APPROVALS_PENDING_SIGNATURE: 'approvalsPendingSignature',
	APPROVALS_SIGNED: 'approvalsSigned',
	APPROVALS_OPERATORS: 'approvalsOperators',
	/**************************************************
	*                  COMPANY PAYMENTS               *
	**************************************************/
	COMPANY_PAYMENTS_REQUEST_TPA: 'companyPaymentsRequestTPA',
	COMPANY_PAYMENTS_BAI_PAGA_MERCHANT: 'companyPaymentsBaiPagaMerchant',
	COMPANY_PAYMENTS_TPA_REQUESTS_LIST: 'companyPaymentsTPARequestsList',
	/**************************************************
	*                      ACCOUNTS                   *
	**************************************************/
	ACCOUNTS_BALANCES_AND_MOVEMENTS: 'accountsBalancesAndMovements',
	ACCOUNTS_PATRIMONY: 'accountsPatrimony',
	ACCOUNTS_CASHFLOW: 'accountsCashflow',
	ACCOUNTS_EXTRACTS: 'accountsExtracts',
	ACCOUNTS_INVOICES: 'accountsInvoices',
	ACCOUNTS_DETAILS: 'accountsDetails',
	ACCOUNTS_WALLET: 'accountsWallet',
	ACCOUNTS_VISIBLE: 'accountsVisible',
	/**************************************************
	*                     TRANSFERS                   *
	**************************************************/
	TRANSFERS_NACIONAL: 'transfersNacional',
	TRANSFERS_INTERNATIONAL: 'transfersInternational',
    TRANSFERS_INTERNATIONAL_CORPORATE: 'transfersInternationalCorporate',
	TRANSFERS_INSTANT_BAI: 'transfersInstantBAI',
	TRANSFERS_KWIK: 'transfersKwik',
	TRANSFERS_REQUEST_NAHORA: 'transfersRequestNaHora',
	TRANSFERS_HISTORY_INTERNATIONAL: 'transfersHistoryInternational',
	TRANSFERS_HISTORY_NACIONAL: 'transfersHistoryNacional',
	TRANSFERS_HISTORY_NAHORA: 'transfersHistoryNaHora',
	TRANSFERS_PERIODIC: 'transfersPeriodic',
	TRANSFERS_BENEFICIARIES: 'transfersBeneficiaries',
	TRANSFERS_REQUESTS_INTERNATIONAL: 'transfersRequestsInternational',
    TRANSFERS_REQUESTS_INTERNATIONAL_CORPORATE: 'transfersRequestsInternationalCorporate',
	TRANSFERS_REQUESTS_NACIONAL_NAHORA_SENT: 'transfersRequestsNacionalNaHoraSent',
	TRANSFERS_REQUESTS_NACIONAL_NAHORA_RECEIVED: 'transfersRequestsNacionalNaHoraReceived',
	/**************************************************
	*                      PAYMENTS                   *
	**************************************************/
	PAYMENTS_BAI_PAGA: 'paymentsBAIPaga',
	PAYMENTS_BATCHFILE_CONSULT: 'paymentsBatchfileConsult',
	PAYMENTS_BATCHFILE_NEW_PAYMENT: 'paymentsBatchfileNewPayment',
	PAYMENTS_SERVICES: 'paymentsServices',
	PAYMENTS_UNITEL: 'paymentsUnitel',
	PAYMENTS_RUPE: 'paymentsRupe',
	PAYMENTS_REFERENCE: 'paymentsReference',
	PAYMENTS_WALLET: 'paymentsWallet',
	PAYMENTS_EMIS_SPECIAL: 'paymentsEmisSpecial',
	PAYMENTS_VOUCHER: 'paymentsVoucher',
	PAYMENTS_REQUESTS_BAI_PAGA: 'paymentsRequestsBaiPaga',
	PAYMENTS_REQUESTS_EKWANZA: 'paymentsRequestsEKwanza',
	PAYMENTS_HISTORY: 'paymentsHistory',
	/**************************************************
	*                       CARDS                     *
	**************************************************/
	CARDS_CARDLESS_WITHDRAW_GENERATE_CODE: 'cardsCardlessWithdrawGenerateCode',
	CARDS_CARDLESS_WITHDRAW_MY_CODES: 'cardsCardlessWithdrawMyCodes',
	CARDS_CONSULT: 'cardsConsult',
	CARDS_ANTICIPATE_PAYMENT: 'cardsAnticipatePayment',
	CARDS_BLOCK: 'cardsBlock',
	CARDS_CANCEL: 'cardsCancel',
	CARDS_CHANGE_PAYMENT: 'cardsChangePayment',
	CARDS_CHARGE: 'cardsCharge',
	CARDS_LIMITS: 'cardsLimits',
	CARDS_TRANSFER: 'cardsTransfer',
	CARDS_ACTIVATE: 'cardsActivate',
	CARDS_REQUEST: 'cardsRequest',
	CARDS_CONSULT_REQUESTS_CANCEL: 'cardsConsultRequestsCancel',
	CARDS_CONSULT_REQUESTS_CHARGE: 'cardsConsultRequestsCharge',
	CARDS_CONSULT_REQUESTS_NEW: 'cardsConsultRequestsNew',
	CARDS_BATCHFILE_CONSULT: 'cardsBatchfileConsult',
	CARDS_BATCHFILE_NEW_CHARGE: 'cardsBatchfileNewCharge',
	CARDS_HISTORY: 'cardsHistory',
	/**************************************************
	*                      CREDITS                    *
	**************************************************/
	CREDITS_MY_CREDITS: 'creditsMyCredits',
	CREDITS_CREDITS_SOLUTIONS: 'creditsCreditSolutions',
    CREDITS_MY_CREDITS_AMORTIZATION: 'creditsMyCreditsAmortization',
	/**************************************************
	*                      SAVINGS                    *
	**************************************************/
	SAVINGS_MY_SAVINGS_PORTFOLIO: 'savingsMySavingsPortefolio',
	SAVINGS_MY_SAVINGS_CHARGE_DP: 'savingsMySavingsChargeDP',
	SAVINGS_PRODUCTS: 'savingsProducts',
	SAVINGS_HISTORY_PORTFOLIO: 'savingsHistoryPortfolio',
	/**************************************************
	*                   BANKASSURANCE                 *
	**************************************************/
	BANKASSURANCE_SUBSCRIBE: 'bankassuranceSubscribe',
	BANKASSURANCE_POLICIES: 'bankassurancePolicies',
	/**************************************************
	*                      AGENCIES                   *
	**************************************************/
	AGENCIES: 'agencies',
	/**************************************************
	*                      EXCHANGES                  *
	**************************************************/
	EXCHANGES: 'exchanges',
	/**************************************************
	*                      FAVORITES                  *
	**************************************************/
	FAVORITES: 'favorites',
	/**************************************************
	*                     USER AREA                   *
	**************************************************/
	USER_AREA_PROFILE: 'userAreaProfile',
	USER_AREA_DEFINITIONS_ACTIVE_CHANNELS: 'userAreaDefinitionsActiveChannels',
	USER_AREA_DEFINITIONS_PASSWORD_CHANGE: 'userAreaDefinitionsPasswordChange',
	USER_AREA_DEFINITIONS_FRIENDLY_USERNAME: 'userAreaDefinitionsFriendlyUsername',
	USER_AREA_DEFINITIONS_ACCOUNTS_GROUPS: 'userAreaDefinitionsAccountGroups',
	USER_AREA_DEFINITIONS_HISTORY: 'userAreaDefinitionsHistory',
	USER_AREA_DEFINITIONS_SECURE_ASSOCIATION_ENROLLMENT: 'userAreaDefinitionsSecureAssociationEnrollment',
    USER_AREA_DEFINITIONS_NOTIFICATIONS: 'userAreaDefinitionsNotifications',
	/**************************************************
	*              LOVS and app Transversal           *
	**************************************************/
	RECOVER_CREDENTIALS: 'recoverCredentials',
    PRE_ACTIVE_MODE: 'preActiveMode',
	LOVS: 'lovs',
	SHARE_AND_SEND_INFO: 'shareAndSendInfo',
	MENU: 'menu',
	SESSION: 'session'
})

export const moduleMapper = buildConstantsMapper(MODULES)
